import { Flex, Tooltip } from "antd"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import BookingConflictWarning from "pagesV2/pro/Calendar/Tooltips/BookingConflictWarning"
import { getEventColor } from "pagesV2/pro/Calendar/utils"
import { getDefaultCalendarColor, getPrimaryCalendarTextColor, resolveBookingColors } from "pagesV2/pro/Calendar/calendarColorUtils"
import { useTheme } from "context/AntdThemeContext"


const EventBlock = ({
  event,
  eventColor,
  conflict,
  setIsBookingModalOpen,
  setSelectedBookingId,
  fullHeight,
  multipleInSlot,
  compact,
  hideTime
}) => {
  const { id, startLabel, endLabel, title, multi_day } = event || {}
  const { theme } = useTheme()

  const handleClick = () => {
    setIsBookingModalOpen(true)
    setSelectedBookingId(event?.id)
  }

  const displayEndLabel = multi_day ? null : endLabel
  const timeRange = startLabel && displayEndLabel ? `${startLabel} – ${displayEndLabel}` : startLabel || null
  const tooltipTitle = [timeRange, title].filter(Boolean).join("\n")

  let timeClassName = styles.eventTime
  if (compact) timeClassName = styles.eventTimeCompact
  else if (multipleInSlot) timeClassName = styles.eventTimeWrap

  let titleClassName = styles.eventTitle
  if (compact) titleClassName = styles.eventTitleCompact
  else if (multipleInSlot) titleClassName = styles.eventTitleWrap

  const primaryTextColor = getPrimaryCalendarTextColor(theme)
  const defaultColor = getDefaultCalendarColor()
  const previewColors = resolveBookingColors(event?.color || eventColor, defaultColor, primaryTextColor, getEventColor)
  const blockClassName = compact ? `${styles.eventBlock} ${styles.eventBlockCompact}` : styles.eventBlock

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={0.5}>
      <button
        type="button"
        key={id || title + startLabel + endLabel}
        className={blockClassName}
        style={{
          backgroundColor: previewColors.backgroundColor,
          borderColor: previewColors.borderColor,
          ...(fullHeight ? { height: "100%" } : {}),
          ...(multipleInSlot ? { whiteSpace: "normal", wordBreak: "break-word" } : {})
        }}
        onClick={handleClick}
      >
        <Flex align="center" justify="space-between" gap={compact ? 2 : 4}>
          {!hideTime && (
            <span className={timeClassName} style={{ color: previewColors.textColor || primaryTextColor }}>
              {multi_day ? startLabel : `${startLabel} - ${endLabel}`}
            </span>
          )}
          {conflict ? <BookingConflictWarning /> : null}
        </Flex>
        <span className={titleClassName} style={{ color: previewColors.textColor || primaryTextColor }}>
          {title}
        </span>
      </button>
    </Tooltip>
  )
}

EventBlock.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    startLabel: PropTypes.string,
    endLabel: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    color: PropTypes.string,
    multi_day: PropTypes.bool
  }),
  eventColor: PropTypes.string,
  setIsBookingModalOpen: PropTypes.func,
  setSelectedBookingId: PropTypes.func,
  conflict: PropTypes.bool,
  fullHeight: PropTypes.bool,
  multipleInSlot: PropTypes.bool,
  compact: PropTypes.bool,
  hideTime: PropTypes.bool
}

export default EventBlock
